import React, { useState } from 'react';
// import { useLocation } from 'react-router-dom';
import ProfileSidebarLeft from './ProfileSidebarLeft';
import ProfileSidebarRight from './ProfileSidebarRight';
import { useActiveLeague } from '../../App';

function ProfileLayout({ children }) {
  // const location = useLocation();
  const { activeLeague, setActiveLeague, activeSeason, setActiveSeason, registrationSeason } = useActiveLeague();

  const [rightSidebarVisible, setRightSidebarVisible] = useState(false);

  const handleRightSidebarVisibility = (isVisible) => {
    setRightSidebarVisible(isVisible);
  };

  // Don't render until we have the active league data to prevent flickering
  if (!activeLeague || !activeSeason) {
    return null;
  }

  return (
    <div className="container-fluid">
      <div className="row g-0 g-lg-4 p-2 p-md-0">
        {/* Left sidebar (always visible) */}
        <div className="col-lg-3">
          <ProfileSidebarLeft />
        </div>

        {/* Right-side content changes depending on route */}
        <div className={rightSidebarVisible ? "col-lg-6 pe-0 pe-lg-4" : "col-lg-9 pe-0 pe-lg-4"} style={{ paddingRight: rightSidebarVisible ? '0' : '1rem' }}>
          {React.cloneElement(children, { activeLeague, setActiveLeague, activeSeason, setActiveSeason, registrationSeason })}
        </div>

        {/* Right sidebar - will be hidden when no content */}
        <ProfileSidebarRight
          activeLeague={activeLeague}
          activeSeason={activeSeason}
          onVisibilityChange={handleRightSidebarVisibility}
        />
      </div>
    </div>
  );
}

export default ProfileLayout;
